import { DataSistemaService } from './../../../../shared/services/data-sistema.service';
import { BnModalMessageService } from '@bndes/bndes-ux4/bn-modal-message';
import { LimiteAdicionalService } from './../../limite-adicional.service';
import { Component } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators, ValidationErrors, FormArray } from '@angular/forms';
import { BaseEntityComponent, BnLoadingService,messageLevel } from '@bndes/bndes-ux4/bndes-angular-utils';
import { LimiteAdicionalTranch, } from '../../../../model/limite-adicional-tranch.model';

import { ProgramasPermtidosPorCestasService } from '../../../programas-permitidos-por-cestas/programas-permitidos-por-cestas.service';

import Utils from "../../../../shared/fgi-utils";
import { DatePipe } from '@angular/common';
import { map, mergeMap, Observable, of } from 'rxjs';
import moment from 'moment';
import { BnUsuarioService, Usuario } from '@bndes/bndes-ux4/bn-usuario';
import { ProgramaRepasseBndes } from '../../../../model/programas-permitidos.model';
import { LimiteAdicionalProgramaBndesTranche } from '../../../../model/limite-adicional-programa-bndes-tranche.model';

@Component({
  selector: 'cadastro-limite-adicional-tranch',
  templateUrl: './cadastro-limite-adicional-tranch.component.html',
  styleUrls: ['./cadastro-limite-adicional-tranch.component.scss'],
  standalone: false

})
export class CadastroLimiteAdicionalTranchComponent extends BaseEntityComponent<LimiteAdicionalTranch> {

  private usuarioLogado!: Usuario;

  public programasPermitidos: ProgramaRepasseBndes[] = [];

  private dataCorrente: Date |null = null;

  public ideTranche?: number;

  public programasSelecionados:ProgramaRepasseBndes[] = [];

  private dataInicioEdicao!: string;
  private dataFimEdicao!: string;


  constructor(
    private usuarioService: BnUsuarioService,
    private limiteAdicionalService: LimiteAdicionalService,
    private programasPermitidosPorCestas: ProgramasPermtidosPorCestasService,
    private modalService: BnModalMessageService,
    private datePipe: DatePipe,
    private loadingService: BnLoadingService,
    private dataSistemService: DataSistemaService,

  ) {
    super(limiteAdicionalService);
  }

  ngOnInit() {

    this.createReactiveForm()

    this.usuarioAtualLogado();

    this.buscarProgramasPermitidosPorTranche();

    this.monitoraMudancaDataParaAtualizarNoValidacaoData();

      this.dataSistemService.getDataCorrente().subscribe(data =>  {
            this.dataCorrente = data;
      });

  }

  private inicializaFornmulario() {

    this.route.params.subscribe(params =>{
      this.ideTranche =params['ideTranche'];
    })

    this.preparaModelo().subscribe((limiteAdicional) => {

      this.programasPermitidosPorCestas.buscarProgramasPermitidosPorTranche(this.ideTranche!)
      .subscribe((ids: ProgramaRepasseBndes[])=>{
        this.programasPermitidos = ids;
        this.setModel(limiteAdicional);

      this.preencheForm(limiteAdicional);
      })

      if (limiteAdicional.id) {
        this.modoEdicao = true;
        this.formGroup.get('nome')?.disable();
      }
    });
  }

  private usuarioAtualLogado() {
    this.usuarioService.usuario$.subscribe((usuario) => {
      if (usuario) {
        this.usuarioLogado = usuario;
        this.inicializaFornmulario();
      }
    });
  }

  protected createReactiveForm(): void {

    this.formGroup = this.formBuilder.group({
      id: [null],
      nome: [null, Validators.required],
      dataInicioProtocolo: [null, [Validators.required, this.validaDataInicio()]],
      dataFimProtocolo: [null, [Validators.required, this.validaDataFinal()]],
      nomeUsuarioEnvio: [{ value: null, disabled: true }],
      limiteAdicionalProgramaBndesTranches:[[]],
      permiteRenunciaLimiteAdicional: [null, Validators.required],
    });
  }

  voltarParaLista(){
    this.router.navigate(['/limite-adicional/pesquisa'])
   }

  habilitarEdicao() {

    this.formGroup.get('nome')?.disable();
  }

  salvar(){

    const formValues = this.formGroup.getRawValue();
    Object.assign(this.model, formValues);

    this.modalService.abrirConfirm(
        'Confirmação',
          this.model.id ? 'As alterações serão salvas. Deseja continuar?' : 'Os dados serão salvos. Deseja continuar ?'
        ).result.then(resp =>{

          this.programasSelecionados = this.model.limiteAdicionalProgramaBndesTranches
          .filter(item => item.programaBndesTranche !=null)
          .map(item => item.programaBndesTranche);

          if(resp?.value === 'ok'){
            this.loadingService.bloqueiaTela();

            const acao = this.model.id != null ?
            this.limiteAdicionalService.editarLimite(this.ideTranche!, this.model, this.programasSelecionados) :
            this.limiteAdicionalService.salvarlimite(this.ideTranche!,this.model, this.programasSelecionados);
               acao.subscribe(

              limiteRetornado =>{
                this.model = limiteRetornado;
                this.loadingService.liberaTela();
                this.aposSalvar();
              },
              error => {
                console.log(" log de erro",error);
                this.loadingService.liberaTela();
              }
            )
        }
      }).catch(()=>{
        console.log('Ação cancelada')
      });
  }

  monitoraMudancaDataParaAtualizarNoValidacaoData() {

    this.formGroup.get('dataInicioProtocolo')?.valueChanges.subscribe(() => {
    this.formGroup.get('dataFimProtocolo')?.updateValueAndValidity({emitEvent:false});
    });


  }

  validaDataInicio(): ValidatorFn {
    return this.verificaDataInicio;
  }

  validaDataFinal(): ValidatorFn {
    return this.verificaDataFinal;
  }

  //Criando validador de data
  verificaDataInicio(control: AbstractControl):ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const hoje = new Date();
    const dataInicio = new Date(control.value);

    if (dataInicio < hoje) {

      return { dataInicioProtocoloInvalida: 'Data de início deve ser maior do que data atual' }
  }
    return null;
  }


   verificaDataFinal(control: AbstractControl):ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const dataInicio = new Date(control.parent?.get('dataInicioProtocolo')?.value);
    const dataFinal = new Date(control.value);

    if (dataFinal > dataInicio) {
      return null;
    }
    return { dataFimProtocoloInvalida: 'Data final não deve ser menor do que data inicio' }
  }

  preencheForm(model: LimiteAdicionalTranch) {

    this.formGroup.patchValue({

      id: model.id ? model.id : null,
      nome: model.nome,
      dataInicioProtocolo: Utils.ajustaCampoDate(model.dataInicioProtocolo),
      dataFimProtocolo: Utils.ajustaCampoDate(model.dataFimProtocolo),
      nomeUsuarioEnvio: model.nomeUsuarioEnvio,
      limiteAdicionalProgramaBndesTranches: model.limiteAdicionalProgramaBndesTranches,
      permiteRenunciaLimiteAdicional: model.permiteRenunciaLimiteAdicional ?? false,

    });

    if(model.id){

      this.formGroup.markAsDirty();

      this.dataInicioEdicao = this.formGroup.get('dataInicioProtocolo')?.value;
      this.dataFimEdicao = this.formGroup.get('dataFimProtocolo')?.value;

      this.formGroup.get('dataInicioProtocolo')?.clearValidators();
      this.formGroup.get('dataInicioProtocolo')?.updateValueAndValidity();

      this.formGroup.get('dataFimProtocolo')?.setValidators([this.validaDataFinal()]);

      this.formGroup.get('dataFimProtocolo')?.updateValueAndValidity();

    }
  }


  preparaModelo(): Observable<LimiteAdicionalTranch> {
    return this.route.params.pipe(
      mergeMap((params) => {

        if (params['idLimite']) {

          return this.limiteAdicionalService.findById(params['idLimite']).pipe(

            map(model =>{

              super.editar();
              return model
            })
          );
        } else {
          const novo: LimiteAdicionalTranch = this.limiteAdicionalService.getNewEntity();
          novo.nomeUsuarioEnvio = this.usuarioLogado.nome!;
          novo.dataInicioProtocolo = moment().add(1,'day').format(('YYYY-MM-DDTHH:mm:ss'));
          novo.dataFimProtocolo = moment().add(2,'day').format(('YYYY-MM-DD'));
          novo.limiteAdicionalProgramaBndesTranches = [];
          novo.permiteRenunciaLimiteAdicional = false;
          super.editar();
          return of(novo);
        }
      })
    );
  }

  buscarProgramasPermitidosPorTranche() {
    if (this.ideTranche) {
      this.programasPermitidosPorCestas.buscarProgramasPermitidosPorTranche(this.ideTranche).subscribe
        ((ids: ProgramaRepasseBndes[]) => {
          this.programasPermitidos = ids;
        })
    }
  }

  adicionarPrograma() {

    const limiteAdicional = <LimiteAdicionalTranch>this.model;

    limiteAdicional.limiteAdicionalProgramaBndesTranches.push(new LimiteAdicionalProgramaBndesTranche);

    this.formGroup.markAsDirty();
  }

  removerPrograma(i: number) {
    const limiteAdicional = <LimiteAdicionalTranch>this.model;
    limiteAdicional.limiteAdicionalProgramaBndesTranches.splice(i, 1);
  }

  atribuirPrograma(idPrograma: number, i: number) {

    const limiteAdicional = <LimiteAdicionalTranch>this.model;
    const programas = limiteAdicional.limiteAdicionalProgramaBndesTranches;

    const jaExiste = programas.some((p,index ) => index !== i && p.programaBndesTranche?.idProgramaBndesTranche == idPrograma);

    if(jaExiste){

      this.modalService.abrir('Atenção','Programa já adicionado!','sm');

      programas[i].programaBndesTranche = undefined!;

      const select = document.getElementById('programa'+i) as HTMLSelectElement;

      if(select){
        select.value = '';
      }
      return;
  }

    const programaSelecionado = this.programasPermitidos.find(
      p => p.idProgramaBndesTranche == idPrograma);

    if (programaSelecionado) {

      limiteAdicional.limiteAdicionalProgramaBndesTranches[i].programaBndesTranche = programaSelecionado;
    }

    this.formGroup.get('limiteAdicionalProgramaBndesTranches');

  }

  podeAdicionarPrograma():boolean{

    const result = this.model.limiteAdicionalProgramaBndesTranches.every(programa => programa && programa.programaBndesTranche) ?? true;
    return result;
    }


  temPeloMenosUmPrograma(): boolean{

    const limiteAdicional = <LimiteAdicionalTranch>this.model;
    const result =  limiteAdicional?.limiteAdicionalProgramaBndesTranches?.some(
      p=> p.programaBndesTranche !== undefined
    ) ?? false;

    return result;

  }

  public aposSalvar(): void {

      this.exibeMensagemSucesso();
      this.modoEdicao = false;
      this.formGroup.markAsPristine();
      this.formGroup.disable();
      this.router.navigate(['limite-adicional/pesquisa'])
  }

  private exibeMensagemSucesso(): void {

    this.messageService.addMessage({
    title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: 'Limite Adicional Tranch criada/atualizada com sucesso.'
          });
      }
}
